import React, {Fragment} from 'react';
import Tabs from 'react-responsive-tabs';
import Localidad from './component/localidad';
import PageTitle from '../../../../Layout/AppMain/PageTitle';



export default class LocalidadComponent extends React.Component {

    render() {

        return (
         <Localidad></Localidad>
        )
    }
}


// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Localidad/index.js